<template lang="pug">
  .tko-tariff
    .body.body-table
      .table-choose-panel
        .toolbar.toolbar_no-padding.toolbar_margin-bottom
          .toolbar__line.line(style="justify-content: space-between" v-if="editParam")
            .parameters
              .semibold {{ title }}
            .actions-panel.view-panel
              e-button-add.btn-add-target.actions-panel__button.view-panel__button.view-panel__button_add(@click="showYearModal = true" label="Добавить")
              e-button-delete.actions-panel__button.actions-panel__button_text.button.reset-btn(
                :label="saveButtonTitle"
                @click="saveTables"
              )
            e-modal(
              v-if="showYearModal"
              title="Выбор года"
              @close="showYearModal=false"
              @confirm="handleYear"
            )
              slot
                input.input(type="number" v-model="year" @change="changeYear")
                input.visually-hidden.custom-checkbox__input(
                  type="checkbox"
                  id="year"
                  v-model="baseYear"
                )
                label.legend__label.custom-checkbox__label(for="year")
                  span.custom-checkbox__block
                  span.custom-checkbox__text Сделать год базовым
                span(v-if="errorFlag") {{ errorText }}
          TariffTable(
            ref="resultTable"
            :title="'Тарифы'"
            :columns="['Статья расходов', 'Ед.изм']"
            :rows="tariffFields"
            :readOnly="!editParam"
            :saveButtonTitle="'Сохранить'"
            :urlPost="calcUrlPost"
          )
</template>

<script>
import TariffTable from './tariff-table.vue'
import tariffTableMixins from '../mixins/tariff-table'
import { map } from '@/api/api-endpoints'

export default {
  name: 'ResultTariffTable',
  components: {
    TariffTable,
  },
  mixins: [tariffTableMixins],
  props: {
    title: {
      type: String,
      default: '',
    },
    columns: {
      type: Array,
      default: () => [],
    },
    rows: {
      type: Array,
      default: () => [],
    },
    saveButtonTitle: {
      type: String,
      default: 'Рассчитать',
    },
    urlPost: {
      type: String,
      default: '',
    },
  },
  methods: {
    changeYear() {
      if (
        Object.keys(this.optionalYears).length &&
        Object.keys(this.optionalYears).includes(this.year)
      ) {
        this.errorFlag = true
        return false
      }
      this.errorFlag = false
      return true
    },
    handleYear() {
      if (!this.changeYear()) return
      this.$refs.resultTable.addFunction({
        year: this.year,
        base_year: this.baseYear,
      })
      this.optionalYears[this.year] = {
        year: this.year,
        base_year: this.baseYear,
      }
      this.errorFlag = false
      this.baseYear = false
      this.showYearModal = false
    },
    saveTables() {
      this.$refs.resultTable.saveTable()
    },
    takeData() {
      new Promise((resolve) => {
        this.$store
          .dispatch('updateUrlEndpoint', {
            endpoint: `${map.tariff_coeff({
              query: {
                apo_id: this.$route.params.id,
                'per-page': -1,
              },
            })}`,
          })
          .then((response) => {
            const data = {}
            response.data.data.map((i) => {
              if (
                data[i.year] &&
                new Date(data[i.year].date).getTime() >
                  new Date(i.date).getTime()
              )
                return
              data[i.year] = i
            })
            this.optionalYears = { ...data }
            resolve(data)
          })
      }).then((coefData) => {
        this.$store
          .dispatch('updateUrlEndpoint', {
            endpoint: `${map.tariff_values({
              query: {
                apo_id: this.$route.params.id,
                'per-page': -1,
              },
            })}`,
          })
          .then((response) => {
            const data = {}
            const promises = []
            for (let year in coefData) {
              const tarif_value = response.data.data.find(
                (i) => i.tariff_coeff_id === coefData[year].id
              )
              if (tarif_value) {
                promises.push(
                  this.$store
                    .dispatch('updateUrlEndpoint', {
                      endpoint: `${map.tariff_values({})}/${tarif_value.id}`,
                    })
                    .then((response) => {
                      data[year] = {
                        ...response.data,
                        base_year: coefData[year].base_year,
                        year: coefData[year].year,
                      }
                    })
                )
              } else {
                data[year] = {
                  base_year: coefData[year].base_year,
                  year: coefData[year].year,
                }
              }
            }
            Promise.all(promises).then(() => {
              this.$refs.resultTable.setYears(data)
            })
          })
      })
    },
  },
}
</script>

<style scoped lang="scss">
.half-block {
  display: flex;
  gap: 15px;
}
</style>
